export default function FormSearchHeader($DOM, classes) {
	const $container = $('.form-header-search');

	if(!$container.length) {
		return false;
	}

	let _timer = null;

	$container.find('a').click(function(event) {
		event.preventDefault();

		const $this = $(this);

		clearTimeout(_timer);

		$DOM.bodyTag.addClass(classes.ShowHeaderSearch);

		_timer = setTimeout(function() {
			$this.parent().find('input[type="search"]').focus();
		}, 550);
	});

	$DOM.bodyTag.click(function(event) {
		const $target = $(event.target);

		if(!$target.parents('.form-header-search').length) {
			$DOM.bodyTag.removeClass(classes.ShowHeaderSearch);		
		}
	});
}